import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as GlobeIcon} from '../../assets/icons/globe.svg';
import {LanguageDropdown, LanguageLabel, LanguageOption, LanguageSwitcherContainer} from './LanguageSwitcher.styled';
import {languages} from "../../config/languages";
import {Tooltip} from "@mui/material";

const LanguageSwitcher: React.FC = () => {
    const {t} = useTranslation();
    const {i18n} = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLButtonElement>(null);

    const currentLanguage = i18n.language;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);


    const handleLanguageChange = (languageCode: string) => {
        i18n.changeLanguage(languageCode);
        localStorage.setItem('language', languageCode);
        setIsDropdownOpen(false);
    };

    const getCurrentLanguageLabel = () => {
        const lang = languages.find(l => l.code === currentLanguage);
        return lang?.shortLabel || 'PL';
    };

    return (
        <Tooltip title={t('sidebar.changeLanguage')}>
            <LanguageSwitcherContainer ref={dropdownRef} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                <GlobeIcon/>
                <LanguageLabel>{getCurrentLanguageLabel()}</LanguageLabel>
                {isDropdownOpen && <LanguageDropdown $isOpen={isDropdownOpen}>
                    {languages.map(lang => (
                        <LanguageOption
                            key={lang.code}
                            $isActive={currentLanguage === lang.code}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleLanguageChange(lang.code);
                            }}
                        >
                            {lang.label}
                        </LanguageOption>
                    ))}
                </LanguageDropdown>}
            </LanguageSwitcherContainer>
        </Tooltip>
    );
};

export default LanguageSwitcher;
